import React from 'react'

const Loader = ({ show }) => (
    !show
        ? null
        : (
            <div id="overlay">
                <div
                    className="loader"
                    style={{
                        color: 'rgba(57,183,183, 1)',
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                    }}
                />
            </div>
        )
)

export default Loader
